/**
 * Counter identifying the current local auth session.
 *
 * Token fetches are asynchronous, so a refresh started before a logout can resolve after
 * it and write the cookies back, resurrecting a session the user already ended. Callers
 * capture the epoch before awaiting a token and compare it before persisting the result.
 */
let authSessionEpoch = 0;

export function getAuthSessionEpoch(): number {
    return authSessionEpoch;
}

/** Invalidates pending token writes. Called wherever local auth cookies are cleared. */
export function invalidateAuthSessionEpoch(): void {
    authSessionEpoch += 1;
}
